import { render, staticRenderFns } from "./Component.Course.vue?vue&type=template&id=4e329960&scoped=true&"
import script from "./Component.Course.vue?vue&type=script&lang=js&"
export * from "./Component.Course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e329960",
  null
  
)

export default component.exports